type LenisOptions = {
    duration?: number;
    easing?: (t: number) => number;
    syncTouch?: boolean;
    touchMultiplier?: number;
    wheelMultiplier?: number;
};

type LenisInstance = {
    raf: (time: number) => void;
    start: () => void;
    stop: () => void;
};

type LenisCtor = new (opts?: LenisOptions) => LenisInstance;

export class SmoothScrollManager {
    static init(): void {
        const Lenis = (window as unknown as { Lenis?: LenisCtor }).Lenis;
        if (!Lenis) return;

        const isTouchDevice = window.matchMedia(
            "(hover: none) and (pointer: coarse)",
        ).matches;

        const lenis = new Lenis({
            duration: isTouchDevice ? 1.1 : 2,
            easing: (t: number) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            syncTouch: false,
            touchMultiplier: isTouchDevice ? 0.75 : 1,
            wheelMultiplier: 1,
        });

        (window as unknown as { lenis: LenisInstance }).lenis = lenis;

        const raf = (time: number) => {
            lenis.raf(time);
            requestAnimationFrame(raf);
        };
        requestAnimationFrame(raf);
    }
}
